import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { DialogContent, DialogContentText, IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';

interface DeletePopUpProps {
  isDialogOpen: boolean,
  onCancel: any,
  onDo: any,
  title: string,
  recordName: string,
  onlyYesButton?: boolean,
  yesButtonText?: string,
  text?: string
}

const useStyles = makeStyles({
  dialog: {
    width: 400
  },
  cancelBtn: {
    backgroundColor: "#ececec",
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    color: '#00152E',
    fontSize: 20,
    fontFamily: 'lato',
    lineHeight: 'normal',
    display: 'flex',
    alignItems: 'center'
  },
  content: {
    color: '#00152E',
    fontSize: 18,
    fontWeight: 700,
    fontFamily: 'lato',
    lineHeight: 'normal',
  },
  icon: {
    fontSize: 26,
    color: 'black'
  },
  onlyYesButtonStyle:{
    width: '100%'
  }
});

const DeletePopUp: React.FC<DeletePopUpProps> = ({
  isDialogOpen,
  onCancel,
  onDo,
  title,
  recordName,
  onlyYesButton,
  yesButtonText,
  text
}) => {
  const classes = useStyles();
  const dialogText = text ? text :
    `Are you sure you would like to delete this ${recordName}?`;
  return (
    <Dialog open={isDialogOpen}
      onClose={onCancel}
      PaperProps={{ className: classes.dialog }}>
      <DialogTitle >
        <div className={classes.titleBox}>
          <span className={classes.title}>{title}</span>
          <span>
            <IconButton
              aria-label="close"
              onClick={onCancel}>
              <CloseIcon className={classes.icon} />
            </IconButton></span>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div className={classes.content}>{dialogText}</div>

        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {onlyYesButton ? null :
          <Button onClick={onCancel} className={classes.cancelBtn}>
            Cancel
          </Button>}
        <Button onClick={onDo} color="primary" 
          className={onlyYesButton?classes.onlyYesButtonStyle:''}>
          {yesButtonText ? yesButtonText : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePopUp;
